import React from 'react';
import { Card, CardContent, Typography, CircularProgress, Box, useTheme } from '@mui/material';
import { ResponsiveContainer, PieChart, Pie, Tooltip, Cell } from 'recharts';

interface SuccessVsFailedProps {
  status: string;
  data: Array<{ name: string; value: number; color: string }>;
}

export const SuccessVsFailed: React.FC<SuccessVsFailedProps> = ({ status, data }) => {
  const theme = useTheme();
  const showSpinner = status !== 'completed';
  return (
    <Card sx={{ height: 400 }}>
      <CardContent>
        <Box display="flex" justifyContent="space-between" alignItems="center" mb={2}>
          <Typography variant="h4" sx={{ fontWeight: 'bold', color: theme.palette.heading?.main ?? theme.palette.secondary.main }}>
            Success vs Failed
          </Typography>
        </Box>
        {showSpinner ? (
          <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: 300 }}>
            <CircularProgress size={48} color="info" />
          </Box>
        ) : (
          data && data.length > 0 ? (
            <ResponsiveContainer width="100%" height={300}>
              <PieChart>
                <Pie
                  data={data}
                  cx="50%"
                  cy="50%"
                  labelLine={false}
                  label={({ name, percent }) => `${name} ${percent ? (percent * 100).toFixed(0) : 0}%`}
                  outerRadius={80}
                  fill="#8884d8"
                  dataKey="value"
                >
                  {data.map((entry, index) => (
                    <Cell key={`cell-${index}`} fill={entry.color} />
                  ))}
                </Pie>
                <Tooltip />
              </PieChart>
            </ResponsiveContainer>
          ) : (
            <Typography variant="body2" color="textSecondary" align="center">
              No data available for pie chart
            </Typography>
          )
        )}
      </CardContent>
    </Card>
  );
};

export default SuccessVsFailed;


